/* eslint-disable no-param-reassign */
import { FETCH_STATUSES } from '../../../utils/fetchStatusUtils';

export default function loadResourcesSlice(options) {
  const { pluralResource, repository } = options;

  return {
    initialState: {
      [pluralResource]: {
        loadingStatus: FETCH_STATUSES.idle,
        items: [],
        meta: {},
        error: null,
      },
    },
    reducers: {
      loadResourcesStart(state) {
        state[pluralResource].loadingStatus = FETCH_STATUSES.pending;
        state[pluralResource].items = [];
        state[pluralResource].error = null;
      },
      loadResourcesSuccess(state, { payload: { items, meta } }) {
        state[pluralResource].loadingStatus = FETCH_STATUSES.fulfilled;
        state[pluralResource].items = items;
        state[pluralResource].meta = meta;
      },
      loadResourcesFail(state, { payload: { errors } }) {
        state[pluralResource].loadingStatus = FETCH_STATUSES.failed;
        state[pluralResource].error = errors;
      },
      loadResourcesReset(state) {
        state[pluralResource].loadingStatus = FETCH_STATUSES.idle;
        state[pluralResource].errors = null;
        state[pluralResource].items = [];
        state[pluralResource].meta = {};
      },
    },
    actionCreators(restDispatch) {
      return {
        loadResources: async (params) => {
          try {
            restDispatch('loadResourcesStart');
            const result = await repository.load(params);
            const { data } = result;
            const successParams = {
              items: data[pluralResource],
              meta: data.meta,
            };
            restDispatch('loadResourcesSuccess', successParams);
          } catch (errors) {
            const { response } = errors;
            const { data } = response;
            restDispatch('loadResourcesFail', data);
            throw errors;
          }
        },
        loadResetResources: () => restDispatch('loadResourcesReset'),
      };
    },
    abstractSelector: (state) => {
      return {
        resources: state[pluralResource],
      };
    },
  };
}
